// extracted by mini-css-extract-plugin
export var fixableContent = "style-mod--fixable-content--31f23";
export var fixableWrapper = "style-mod--fixable-wrapper--271d1";
export var fixableWrapperAnnouncBar = "style-mod--fixable-wrapper-announc-bar--b8358";
export var fixableWrapperBestseller = "style-mod--fixable-wrapper-bestseller--6a53a";
export var fixableWrapperHideHeaderBar = "style-mod--fixable-wrapper-hide-header-bar--e09dc";
export var scrollFixed = "style-mod--scroll-fixed--1e362";
export var scrollShow = "style-mod--scroll-show--0d293";